export default {
  reset_password_title: "Reset Password",
  invalid_reset_token: "Password reset link is invalid or has expired",
  invalid_reset_token_desc:
    "The password reset link you provided is invalid or has expired. Please request a new password reset link.",
  password_reset_success: "Your password has been successfully reset",
  password_reset_success_desc:
    "Your password has been successfully changed. You can now log in with your new password.",
  reset_password_desc: "Please enter your new password below",
  password_required: "Please enter your password",
  password_invalid:
    "Password must be at least 8 characters and contain letters, numbers, and special characters",
  password_placeholder: "Enter your password",
  confirm_password_required: "Please confirm your password",
  passwords_do_not_match: "The two passwords you entered do not match",
  confirm_password_placeholder: "Confirm password",
  reset_password: "Set New Password",
  password_same_as_old: "New password cannot be the same as the old password",
  password_reset_failed: "Password reset failed",
};
